import React from 'react';
import './assets/loading.scss';

const ProductLoading = () => <div className='loading loading--product' />;

export default ProductLoading;
